module.exports = __webpack_public_path__ + "img/删除.a148948e.svg";